import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {Principal} from '../shared/auth/principal.service';
import {AuthInterceptor} from '../shared/auth/auth.interceptor';
import { MatIconRegistry } from '@angular/material/icon';
import {KitchenAppComponent} from './kitchen-app.component';
import {kitchenRoutes} from './kitchen-app.route';
import {KnMainComponent} from './layout/kn-main.component';
import {KnProfileComponent} from './profile/kn-profile.component';
import {KitchenDashboardService} from './dashboard/kitchen-dashboard.service';
import {KitchenDashboardModule} from './dashboard/kitchen-dashboard.module';
import {UserResolver} from '../shared/resolvers/user.resolver';
import {ReportsService} from './shared/services/reports.service';
import {KitchenSharedModule} from './shared/kitchen-shared.module';
import {ReportBuilderModule} from './report-builder/report-builder.module';
import {AppSidebarService} from '../shared/services/app-sidebar.service';
import {RouterExtService} from '../shared/services/router-ext.service';
import { PubBlockRequestService } from '../shared/services/pub-block-request.service';
import {AppApprovalRejectDialogComponent} from './publishers/details/apps/kn-app-approval-reject-dialog.component';
import {AppApprovalArchiveDialogComponent} from './publishers/details/apps/kn-app-approval-archive-dialog.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(kitchenRoutes,
      {
        useHash: true,
        // enableTracing: true  // <-- debugging purposes only
      }),
    KitchenSharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    KitchenDashboardModule,
    ReportBuilderModule,
  ],
  declarations: [
    KnMainComponent,
    KitchenAppComponent,
    KnProfileComponent,
    AppApprovalRejectDialogComponent,
    AppApprovalArchiveDialogComponent
  ],
  providers: [
    MatIconRegistry,
    Principal,
    RouterExtService,
    UserResolver,
    ReportsService,
    PubBlockRequestService,
    AppSidebarService,
    KitchenDashboardService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  exports: [],
  entryComponents: [],
  bootstrap: [KitchenAppComponent]
})
export class KitchenAppModule {
}
